import React from 'react'

const ToggleButtons = ({
    buttons
}) => {
    if (!buttons || !buttons.length) {
        return null
    }

    return (
        <div className={'toggle-button-list'}>
            {buttons.map(({
                isChecked,
                label,
                icon,
                callback
            }, index) => (
                <label
                    key={index}
                    className={`toggle-button ${isChecked ? 'checked' : ''} tooltip-trigger`}
                    onClick={e => {
                        e.stopPropagation()
                        callback()
                    }}
                >
                    {icon.startsWith('fe-') ?
                        <i className={`fe ${icon}`} />
                        :
                        <img className="icon" src={document.base + '/images/icons/' + icon + '.png'} />
                    }
                    <div className={'tooltip'}>
                        {label}
                    </div>
                </label>
            ))}
        </div>
    )
}

export default ToggleButtons